export default "__VITE_ASSET__5faefac5__"